import { api } from '@/infra/axios';

export const getDockerCatalog = async () => {
  return api.get(`/docker/catalog`);
};

export const getTags = async (name) => {
  return api.get(`/docker${name}/tags`);
};
